import { Box, Divider, Stack } from '@mui/material'
import { useGetMilkingProcessDeviationList } from 'hook/query/useGetMilkingProcessDeviationList'
import { ShiftOptions } from 'models/ICattlesData'
import { MilkingProcessDeviationType } from 'models/MilkingProcess'
import { useEffect, useState } from 'react'
import { CardStandart } from 'ui/CardStandart'
import CustomPagination from 'ui/CustomPagination'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { DeviationExportButton } from './DeviationExportButton'
import { DeviationTable } from './deviation-table/DeviationTable'
import { useDeviationSorting } from './deviation-table/hooks/useDeviationSorting'
import { useDeviationTypesFilter } from './deviation-table/hooks/useDeviationTypesFilter'
import { useMilkersFilter } from './deviation-table/hooks/useMilkersFilter'

type DeviationTableListCardProps = {
	startDate: number
	endDate: number
	shift: ShiftOptions[] | 'all'
	parlorId: number[] | 'all'
	hasNoSourceData?: boolean
}

const PAGE_SIZE = 36

export const DeviationTableListCard = (props: DeviationTableListCardProps) => {
	const { startDate, endDate, parlorId, shift, hasNoSourceData } = props
	const [page, setPage] = useState<number>(1)

	useEffect(() => {
		setPage(1)
	}, [startDate, endDate, shift, parlorId])
	const [selectedMilkers, setSelectedMilkers] = useState<number[]>([])
	const [selectedDeviationTypes, setSelectedDeviationTypes] = useState<
		MilkingProcessDeviationType[]
	>([])
	const { milkersForFilter } = useMilkersFilter()
	const { deviationTypesForFilter } = useDeviationTypesFilter()
	const { sortingState, ordering, isRowNumberReversed, toggleSort } =
		useDeviationSorting()

	const milkerId: number[] | 'all' =
		selectedMilkers.length > 0 ? selectedMilkers : 'all'
	const deviationType: MilkingProcessDeviationType[] | 'all' =
		selectedDeviationTypes.length > 0 ? selectedDeviationTypes : 'all'

	const {
		data: milkingDeviationsResponse,
		isLoading,
		isError,
	} = useGetMilkingProcessDeviationList(
		startDate,
		endDate,
		shift,
		page,
		PAGE_SIZE,
		parlorId,
		milkerId,
		deviationType,
		ordering,
	)

	const isListEmpty = (milkingDeviationsResponse?.count ?? 0) === 0
	const emptyState: 'no-data' | 'no-deviations' | null = isLoading
		? null
		: isError || hasNoSourceData || !milkingDeviationsResponse
			? 'no-data'
			: isListEmpty
				? 'no-deviations'
				: null

	return (
		<CardStandart
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between',
				padding: '24px',
			}}
		>
			<Box display='flex' alignItems='center' justifyContent='space-between'>
				<TypographyHeader>Список отклонений</TypographyHeader>

				<DeviationExportButton
					startDate={startDate}
					endDate={endDate}
					shift={shift}
					parlorId={parlorId}
					milkerId={milkerId}
					deviationType={deviationType}
					ordering={ordering}
				/>
			</Box>

			<Stack direction={'column'} height={380}>
				<DeviationTable
					deviations={milkingDeviationsResponse}
					isLoading={isLoading}
					emptyState={emptyState}
					page={page}
					pageSize={PAGE_SIZE}
					setPage={setPage}
					milkersForFilter={milkersForFilter}
					setSelectedMilkers={setSelectedMilkers}
					deviationTypesForFilter={deviationTypesForFilter}
					setSelectedDeviationTypes={setSelectedDeviationTypes}
					sortingState={sortingState}
					isRowNumberReversed={isRowNumberReversed}
					toggleSort={toggleSort}
				/>

				<Divider />
				<Box mt='16px'>
					<CustomPagination
						page={page}
						onChangeFromServer={setPage}
						count={PAGE_SIZE}
						totalCount={milkingDeviationsResponse?.count}
					/>
				</Box>
			</Stack>
		</CardStandart>
	)
}
